import React, { FunctionComponent } from 'react';

import styles from './Icon.module.css';
import Adjust from '../../svgs/adjust.svg';
import AlertCircle from '../../svgs/alertCircle.svg';
import AlertTriangle from '../../svgs/alertTriangle.svg';
import AngleDoubleLeft from '../../svgs/angleDoubleLeft.svg';
import AngleDoubleRight from '../../svgs/angleDoubleRight.svg';
import AngleDown from '../../svgs/angleDown.svg';
import AngleLeft from '../../svgs/angleLeft.svg';
import AngleRight from '../../svgs/angleRight.svg';
import AngleUp from '../../svgs/angleUp.svg';
import ArrowDown from '../../svgs/arrowDown.svg';
import ArrowLeft from '../../svgs/arrowLeft.svg';
import ArrowRight from '../../svgs/arrowRight.svg';
import ArrowUp from '../../svgs/arrowUp.svg';
import BanOutline from '../../svgs/banOutline.svg';
import Beach from '../../svgs/beach.svg';
import BellRing from '../../svgs/bellRing.svg';
import CalendarFilled from '../../svgs/calendarFilled.svg';
import CalendarOutline from '../../svgs/calendarOutline.svg';
import CheckCircleFilled from '../../svgs/checkCircleFilled.svg';
import CheckCircleOutline from '../../svgs/checkCircleOutline.svg';
import CheckDefault from '../../svgs/checkDefault.svg';
import CircleError from '../../svgs/circleError.svg';
import Clipboard from '../../svgs/clipboard.svg';
import ClipboardSignature from '../../svgs/clipboardSignature.svg';
import Clock2 from '../../svgs/clock2.svg';
import ClockFilled from '../../svgs/clockFilled.svg';
import ClockOutline from '../../svgs/clockOutline.svg';
import CopyFilled from '../../svgs/copyFilled.svg';
import CopyOutline from '../../svgs/copyOutline.svg';
import CreditCardFilled from '../../svgs/creditCardFilled.svg';
import Download from '../../svgs/download.svg';
import DragDrop from '../../svgs/dragDrop.svg';
import EmailOutline from '../../svgs/emailOutline.svg';
import Euro from '../../svgs/euro.svg';
import Exchange from '../../svgs/exchange.svg';
import ExclamationTriangleFilled from '../../svgs/exclamationTriangleFilled.svg';
import ExclamationTriangleOutline from '../../svgs/exclamationTriangleOutline.svg';
import ExternalLink from '../../svgs/externalLink.svg';
import EyeFilled from '../../svgs/eyeFilled.svg';
import EyeHiddenFilled from '../../svgs/eyeHiddenFilled.svg';
import EyeOutline from '../../svgs/eyeOutline.svg';
import FileEmptyFilled from '../../svgs/fileEmptyFilled.svg';
import FileVisualizationFilled from '../../svgs/fileVisualizationFilled.svg';
import FileVisualizationOutline from '../../svgs/fileVisualizationOutline.svg';
import FileWithItemsFilled from '../../svgs/fileWithItemsFilled.svg';
import FileWithItemsOutline from '../../svgs/fileWithItemsOutline.svg';
import FilterFilled from '../../svgs/filterFilled.svg';
import GearOutline from '../../svgs/gearOutline.svg';
import HamburgerMenu from '../../svgs/hamburgerMenu.svg';
import HomeFilled from '../../svgs/homeFilled.svg';
import HouseFilled from '../../svgs/houseFilled.svg';
import InfoCircleFilled from '../../svgs/infoCircleFilled.svg';
import InfoCircleOutline from '../../svgs/infoCircleOutline.svg';
import Link from '../../svgs/link.svg';
import ListFilter from '../../svgs/listFilter.svg';
import LockCloseFilled from '../../svgs/lockCloseFilled.svg';
import LockOpenFilled from '../../svgs/lockOpenFilled.svg';
import Mailbox from '../../svgs/mailbox.svg';
import MicrophoneOutline from '../../svgs/microphoneOutline.svg';
import Minus from '../../svgs/minus.svg';
import MultipleUsersOutline from '../../svgs/multipleUsersOutline.svg';
import PenFilled from '../../svgs/penFilled.svg';
import Percent from '../../svgs/percent.svg';
import PhoneFilled from '../../svgs/phoneFilled.svg';
import PhoneOutline from '../../svgs/phoneOutline.svg';
import Plus from '../../svgs/plus.svg';
import PlusCircle from '../../svgs/plusCircle.svg';
import Pound from '../../svgs/pound.svg';
import QuestionMarkFilled from '../../svgs/questionMarkFilled.svg';
import QuestionMarkOutline from '../../svgs/questionMarkOutline.svg';
import RefreshCcw from '../../svgs/refreshCcw.svg';
import Rocket from '../../svgs/rocket.svg';
import Save from '../../svgs/save.svg';
import SearchCheck from '../../svgs/searchCheck.svg';
import ShieldCheck from '../../svgs/shieldCheck.svg';
import Sort from '../../svgs/sort.svg';
import StarFilled from '../../svgs/starFilled.svg';
import StarOutline from '../../svgs/starOutline.svg';
import Sync from '../../svgs/sync.svg';
import TimesDefault from '../../svgs/timesDefault.svg';
import TimesFilled from '../../svgs/timesFilled.svg';
import TrashFilled from '../../svgs/trashFilled.svg';
import TrashOutline from '../../svgs/trashOutline.svg';
import Upload from '../../svgs/upload.svg';
import UserCheck from '../../svgs/userCheck.svg';
import UserFilled from '../../svgs/userFilled.svg';
import ZoomOutline from '../../svgs/zoomOutline.svg';

export const Icons = [
  'download',
  'angleDown',
  'angleLeft',
  'checkCircleFilled',
  'exclamationTriangleFilled',
  'link',
  'fileWithItemsOutline',
  'upload',
  'plus',
  'alertCircle',
  'infoCircleOutline',
  'questionMarkOutline',
  'penFilled',
  'trashOutline',
  'timesFilled',
  'angleUp',
  'angleRight',
  'timesDefault',
  'sync',
  'minus',
  'rocket',
  'multipleUsersOutline',
  'externalLink',
  'hamburgerMenu',
  'banOutline',
  'calendarOutline',
  'houseFilled',
  'arrowLeft',
  'questionMarkFilled',
  'calendarFilled',
  'beach',
  'starFilled',
  'userFilled',
  'creditCardFilled',
  'homeFilled',
  'fileEmptyFilled',
  'fileVisualizationFilled',
  'clockFilled',
  'exclamationTriangleOutline',
  'phoneFilled',
  'zoomOutline',
  'adjust',
  'copyOutline',
  'gearOutline',
  'refreshCcw',
  'searchCheck',
  'clipboardSignature',
  'fileWithItemsFilled',
  'copyFilled',
  'lockOpenFilled',
  'angleDoubleRight',
  'angleDoubleLeft',
  'bellRing',
  'listFilter',
  'checkDefault',
  'lockCloseFilled',
  'circleError',
  'trashFilled',
  'infoCircleFilled',
  'emailOutline',
  'dragDrop',
  'checkCircleOutline',
  'phoneOutline',
  'clipboard',
  'shieldCheck',
  'eyeOutline',
  'filterFilled',
  'starOutline',
  'clock2',
  'exchange',
  'save',
  'mailbox',
  'microphoneOutline',
  'plusCircle',
  'checkDefault',
  'filterFilled',
  'clockOutline',
  'userCheck',
  'alertTriangle',
  'arrowRight',
  'pound',
  'fileVisualizationOutline',
  'eyeHiddenFilled',
  'eyeFilled',
  'arrowUp',
  'sort',
  'arrowDown',
  'euro',
  'percent',
] as const;
export type IconNames = (typeof Icons)[number];

type IconType = React.SVGProps<SVGElement> & {
  icon: IconNames;
};

function getIconSvg(name: IconNames) {
  switch (name) {
    case 'arrowDown':
      return ArrowDown;
    case 'arrowUp':
      return ArrowUp;
    case 'sort':
      return Sort;
    case 'adjust':
      return Adjust;
    case 'alertCircle':
      return AlertCircle;
    case 'alertTriangle':
      return AlertTriangle;
    case 'angleDoubleLeft':
      return AngleDoubleLeft;
    case 'angleDoubleRight':
      return AngleDoubleRight;
    case 'angleDown':
      return AngleDown;
    case 'angleLeft':
      return AngleLeft;
    case 'angleRight':
      return AngleRight;
    case 'angleUp':
      return AngleUp;
    case 'arrowLeft':
      return ArrowLeft;
    case 'arrowRight':
      return ArrowRight;
    case 'banOutline':
      return BanOutline;
    case 'beach':
      return Beach;
    case 'bellRing':
      return BellRing;
    case 'calendarFilled':
      return CalendarFilled;
    case 'calendarOutline':
      return CalendarOutline;
    case 'checkCircleFilled':
      return CheckCircleFilled;
    case 'checkCircleOutline':
      return CheckCircleOutline;
    case 'checkDefault':
      return CheckDefault;
    case 'circleError':
      return CircleError;
    case 'clipboard':
      return Clipboard;
    case 'clipboardSignature':
      return ClipboardSignature;
    case 'clock2':
      return Clock2;
    case 'clockFilled':
      return ClockFilled;
    case 'clockOutline':
      return ClockOutline;
    case 'copyFilled':
      return CopyFilled;
    case 'copyOutline':
      return CopyOutline;
    case 'creditCardFilled':
      return CreditCardFilled;
    case 'download':
      return Download;
    case 'dragDrop':
      return DragDrop;
    case 'emailOutline':
      return EmailOutline;
    case 'exchange':
      return Exchange;
    case 'exclamationTriangleFilled':
      return ExclamationTriangleFilled;
    case 'exclamationTriangleOutline':
      return ExclamationTriangleOutline;
    case 'externalLink':
      return ExternalLink;
    case 'eyeFilled':
      return EyeFilled;
    case 'eyeHiddenFilled':
      return EyeHiddenFilled;
    case 'eyeOutline':
      return EyeOutline;
    case 'fileEmptyFilled':
      return FileEmptyFilled;
    case 'fileVisualizationFilled':
      return FileVisualizationFilled;
    case 'fileVisualizationOutline':
      return FileVisualizationOutline;
    case 'fileWithItemsFilled':
      return FileWithItemsFilled;
    case 'fileWithItemsOutline':
      return FileWithItemsOutline;
    case 'filterFilled':
      return FilterFilled;
    case 'gearOutline':
      return GearOutline;
    case 'hamburgerMenu':
      return HamburgerMenu;
    case 'homeFilled':
      return HomeFilled;
    case 'houseFilled':
      return HouseFilled;
    case 'infoCircleFilled':
      return InfoCircleFilled;
    case 'infoCircleOutline':
      return InfoCircleOutline;
    case 'link':
      return Link;
    case 'listFilter':
      return ListFilter;
    case 'lockCloseFilled':
      return LockCloseFilled;
    case 'lockOpenFilled':
      return LockOpenFilled;
    case 'mailbox':
      return Mailbox;
    case 'microphoneOutline':
      return MicrophoneOutline;
    case 'minus':
      return Minus;
    case 'multipleUsersOutline':
      return MultipleUsersOutline;
    case 'penFilled':
      return PenFilled;
    case 'phoneFilled':
      return PhoneFilled;
    case 'phoneOutline':
      return PhoneOutline;
    case 'plus':
      return Plus;
    case 'plusCircle':
      return PlusCircle;
    case 'pound':
      return Pound;
    case 'questionMarkFilled':
      return QuestionMarkFilled;
    case 'questionMarkOutline':
      return QuestionMarkOutline;
    case 'refreshCcw':
      return RefreshCcw;
    case 'rocket':
      return Rocket;
    case 'save':
      return Save;
    case 'searchCheck':
      return SearchCheck;
    case 'shieldCheck':
      return ShieldCheck;
    case 'starFilled':
      return StarFilled;
    case 'starOutline':
      return StarOutline;
    case 'sync':
      return Sync;
    case 'timesDefault':
      return TimesDefault;
    case 'timesFilled':
      return TimesFilled;
    case 'trashFilled':
      return TrashFilled;
    case 'trashOutline':
      return TrashOutline;
    case 'upload':
      return Upload;
    case 'userCheck':
      return UserCheck;
    case 'userFilled':
      return UserFilled;
    case 'zoomOutline':
      return ZoomOutline;
    case 'euro':
      return Euro;
    case 'percent':
      return Percent;
  }
}

export const Icon: FunctionComponent<IconType> = ({
  icon,
  fill,
  ...iconProps
}) => {
  const Icon = getIconSvg(icon);

  return (
    <Icon className={styles.iwIcon} style={{ fill: fill }} {...iconProps} />
  );
};
